import React, { useState } from 'react';
import ImagePickerModal from '../../master/ImagePickerModal';
import { url } from '../../../utils/variables';
import { getDirection, pexios , toast } from '../../../utils/functions';
import Timer from '../../master/Timer';
import addImage from '../../../assets/images/add_image.png';
import { useTranslation } from 'react-i18next';

export default function RegisterImages({changeStep,car_type_id,register_id,history}) {
    // constructor(props) {
    //     super(props);
    //     this.state = {
    //         images:[],
    //         extraImages:[],
    //         damagesImages:[],
    //     }
    // }
    const { t, i18n } = useTranslation();
    const [data,setData] = useState({
        images:[],
        extraImages:[],
        damagesImages:[],
    })
    function renderButton(name) {
        // let img = this.state.images.find(itm => itm.filename === name);
        let img = data.images.find(itm => itm.filename === name);
        return (
            <img
                src={
                    img ?
                        `${url}/files?uid=${img.uid}&width=70&height=70` :
                        addImage
                }
                style={{width: 70, height: 70,marginTop:10}}
                alt='images'
            />
        );
    }
    function finishUpload(image, done, name, type) {
        let { images , extraImages, damagesImages } = data;
        let fd = new FormData();
        fd.append('id', register_id);
        fd.append('type','register');
        fd.append(name, image);
        pexios('api/upload_image','post', fd,true).then(res => {
            if (type === 'extra')
                extraImages.push(res.data);
            else if(type === 'damage')
                damagesImages.push(res.data)
            else {
                const index = images.findIndex(itm => itm.filename === name);
                if (index !== -1)
                    images[index] = res.data;
                else
                    images.push(res.data);
            }
           setData({
                    images,
                    extraImages,
                    damagesImages,
                });
            done();
        }).catch(err=>{
            console.log(err.response)
        });
    }
    function validate(){
        const { images } = data;
        const filledImages = images.reduce((arr, img) => {
           return [
               ...arr,
               img.filename,
           ];
        }, []);
        const mainImage = [
            {key: t('Vehicle plate'), value: filledImages.includes('plate')},
            {key: t('Vehicle card'), value: filledImages.includes('vehicle_card')},
            {key: t('Vehicle card back'), value: filledImages.includes('vehicle_card_back')},
            {key: t('Front vehicle'), value: filledImages.includes('car-front')},
            {key: t('Back vehicle'), value: filledImages.includes('car-back')},
            {key: t('Left side vehicle'), value: filledImages.includes('car-left')},
            {key: t('Right side vehicle'), value: filledImages.includes('car-right')},
            {key: t('Motor image'), value: filledImages.includes('motor')},
            {key: t('Engraved chassis number'), value: filledImages.includes('chassis')},
            {key: t('Plate chassis'), value: filledImages.includes('plate_chassis')},
            {key: t('Kilometr image'), value: filledImages.includes('kilometer')},
            {key: t('Dashboard'), value: filledImages.includes('dashboard')},
            // {key: 'داخل کابین', value: filledImages.includes('cabin')},
            {key: t('Front glass'), value: filledImages.includes('front_glass')},
            {key: t('Green card'),value: filledImages.includes('green_card')},
        ];
        let conditionImages = [];
        if (car_type_id === 1)
            conditionImages = [
                {key:t('Car ceiling'),value: filledImages.includes('car-ceiling')},
                {key:t('Trunk'),value: filledImages.includes('trunk')},
                {key:t('Under trunk'),value: filledImages.includes('under_trunk')},
                {key: t('Back glass'), value: filledImages.includes('back_glass')},
            ];
        else if([6,7,9].includes(car_type_id))
            conditionImages = [
                {key:t('Tire'),value: filledImages.includes('tire')},
                {key:t('Using'),value: filledImages.includes('using')},
            ];
        let error = '';
        [...mainImage, ...conditionImages].forEach(itm => {
            if (!itm.value) error = `${error}, ${itm.key}`;
        })
        // if (error) toast(`عکس های اجباری ${error} را بارگزاری کنید.`, 'error');
        if (error) toast(t('Upload reqired images',{error:error}), 'error');
        else changeStep(3);
    }
    // render() {
        return (
            <>
                <div className='text-box mt20'>
                    <p className='text-justify'>{t('Register Uploading image')}</p>
                </div>
                <div className='text-center mt10'>
                    <p>{t('Times left to upload register images')}:</p>
                    <Timer seconds={1200} onFinish={()=>history.push('/splash')} />
                </div>
                <div className={`row ${getDirection(i18n.language) === 'leftToRight' && 'flex-row-reverse'}`}>
                    <div className='col-6'>
                        <div style={{backgroundColor:'#fff',padding:10,alignItems:'flex-end'}}>
                            <p style={{fontSize:12}}>{t('Vehicle plate')}</p>
                            <ImagePickerModal
                                disableGallery
                                renderBtn={renderButton('plate')}
                                upload={(image, done) => finishUpload(image, done, 'plate')}
                                label='expert_plate'
                            />
                        </div>
                    </div>
                    <div className='col-6'>
                        <div style={{backgroundColor:'#fff',padding:10,alignItems:'flex-end'}}>
                            <p style={{fontSize:12}}>{t('Vehicle card')}</p>
                            <ImagePickerModal
                                disableGallery
                                renderBtn={renderButton('vehicle_card')}
                                upload={(image, done) => finishUpload(image, done, 'vehicle_card')}
                                label='vehicle_card_image'
                            />
                        </div>
                    </div>
                    <div className='col-6'>
                        <div style={{backgroundColor:'#fff',padding:10,alignItems:'flex-end'}}>
                            <p style={{fontSize:12}}>{t('Vehicle card back')}</p>
                            <ImagePickerModal
                                disableGallery
                                renderBtn={renderButton('vehicle_card_back')}
                                upload={(image, done) => finishUpload(image, done, 'vehicle_card_back')}
                                label='vehicle_card_back_image'
                            />
                        </div>
                    </div>
                    <div className='col-6'>
                        <div style={{backgroundColor:'#fff',padding:10,alignItems:'flex-end'}}>
                            <p style={{fontSize:12}}>{t('Green card')}</p>
                            <ImagePickerModal
                                disableGallery
                                renderBtn={renderButton('green_card')}
                                upload={(image, done) => finishUpload(image, done, 'green_card')}
                                label='green-card'
                            />
                        </div>
                    </div>
                    <div className='col-6'>
                        <div style={{backgroundColor:'#fff',padding:10,alignItems:'flex-end'}}>
                            <p style={{fontSize:12}}>{t('Front vehicle')}</p>
                            <ImagePickerModal
                                disableGallery
                                renderBtn={renderButton('car-front')}
                                upload={(image, done) => finishUpload(image, done, 'car-front')}
                                label='front_image'
                            />
                        </div>
                    </div>
                    <div className='col-6'>
                        <div style={{backgroundColor:'#fff',padding:10,alignItems:'flex-end'}}>
                            <p style={{fontSize:12}}>{t('Back vehicle')}</p>
                            <ImagePickerModal
                                disableGallery
                                renderBtn={renderButton('car-back')}
                                upload={(image, done) => finishUpload(image, done, 'car-back')}
                                label='back_image'
                            />
                        </div>
                    </div>
                    <div className='col-6'>
                        <div style={{backgroundColor:'#fff',padding:10,alignItems:'flex-end'}}>
                            <p style={{fontSize:12}}>{t('Left side vehicle')}</p>
                            <ImagePickerModal
                                disableGallery
                                renderBtn={renderButton('car-left')}
                                upload={(image, done) => finishUpload(image, done, 'car-left')}
                                label='left_image'
                            />
                        </div>
                    </div>
                    <div className='col-6'>
                        <div style={{backgroundColor:'#fff',padding:10,alignItems:'flex-end'}}>
                            <p style={{fontSize:12}}>{t('Right side vehicle')}</p>
                            <ImagePickerModal
                                disableGallery
                                renderBtn={renderButton('car-right')}
                                upload={(image, done) => finishUpload(image, done, 'car-right')}
                                label='right_image'
                            />
                        </div>
                    </div>
                    <div className='col-6'>
                        <div style={{backgroundColor:'#fff',padding:10,alignItems:'flex-end'}}>
                            <p style={{fontSize:12}}>{t('Front glass')}</p>
                            <ImagePickerModal
                                disableGallery
                                renderBtn={renderButton('front_glass')}
                                upload={(image, done) => finishUpload(image, done, 'front_glass')}
                                label='front_glass'
                            />
                        </div>
                    </div>
                    <div className='col-6'>
                        <div style={{backgroundColor:'#fff',padding:10,alignItems:'flex-end'}}>
                            <p style={{fontSize:12}}>{t('Motor image')}</p>
                            <ImagePickerModal
                                disableGallery
                                renderBtn={renderButton('motor')}
                                upload={(image, done) => finishUpload(image, done, 'motor')}
                                label='motor'
                            />
                        </div>
                    </div>
                    <div className='col-6'>
                        <div style={{backgroundColor:'#fff',padding:10,alignItems:'flex-end'}}>
                            <p style={{fontSize:12}}>{t('Engraved chassis number')}</p>
                            <ImagePickerModal
                                disableGallery
                                renderBtn={renderButton('chassis')}
                                upload={(image, done) => finishUpload(image, done, 'chassis')}
                                label='chassis_number'
                            />
                        </div>
                    </div>
                    <div className='col-6'>
                        <div style={{backgroundColor:'#fff',padding:10,alignItems:'flex-end'}}>
                            <p style={{fontSize:12}}> {t('Plate chassis')}</p>
                            <ImagePickerModal
                                disableGallery
                                renderBtn={renderButton('plate_chassis')}
                                upload={(image, done) => finishUpload(image, done, 'plate_chassis')}
                                label='plate_chassis'
                            />
                        </div>
                    </div>
                    {/* <div className='col-6'>
                        <div style={{backgroundColor:'#fff',padding:10,alignItems:'flex-end'}}>
                            <p style={{fontSize:12}}>داخل کابین</p>
                            <ImagePickerModal
                                disableGallery
                                renderBtn={this.renderButton('cabin')}
                                upload={(image, done) => this.finishUpload(image, done, 'cabin')}
                            />
                        </div>
                    </div> */}
                    <div className='col-6'>
                        <div style={{backgroundColor:'#fff',padding:10,alignItems:'flex-end'}}>
                            <p style={{fontSize:12}}>{t('Kilometr image')}</p>
                            <ImagePickerModal
                                disableGallery
                                renderBtn={renderButton('kilometer')}
                                upload={(image, done) => finishUpload(image, done, 'kilometer')}
                                label='kilometer'
                            />
                        </div>
                    </div>
                    <div className='col-6'>
                        <div style={{backgroundColor:'#fff',padding:10,alignItems:'flex-end'}}>
                            <p style={{fontSize:12}}>{t('Dashboard')}</p>
                            <ImagePickerModal
                                disableGallery
                                renderBtn={renderButton('dashboard')}
                                upload={(image, done) => finishUpload(image, done, 'dashboard')}
                                label='dashboard'
                            />
                        </div>
                    </div>
                    {
                        car_type_id===1?
                            <>
                                <div className='col-6'>
                                    <div style={{backgroundColor:'#fff',padding:10,alignItems:'flex-end'}}>
                                        <p style={{fontSize:12}}>{t('Car ceiling')}</p>
                                        <ImagePickerModal
                                            disableGallery
                                            renderBtn={renderButton('car-ceiling')}
                                            upload={(image, done) => finishUpload(image, done, 'car-ceiling')}
                                            label='car-ceiling'
                                        />
                                    </div>
                                </div>
                                <div className='col-6'>
                                    <div style={{backgroundColor:'#fff',padding:10,alignItems:'flex-end'}}>
                                        <p style={{fontSize:12}}>{t('Trunk')}</p>
                                        <ImagePickerModal
                                            disableGallery
                                            renderBtn={renderButton('trunk')}
                                            upload={(image, done) => finishUpload(image, done, 'trunk')}
                                            label='trunk'
                                        />
                                    </div>
                                </div>
                                <div className='col-6'>
                                    <div style={{backgroundColor:'#fff',padding:10,alignItems:'flex-end'}}>
                                        <p style={{fontSize:12}}>{t('Under trunk')}</p>
                                        <ImagePickerModal
                                            disableGallery
                                            renderBtn={renderButton('under_trunk')}
                                            upload={(image, done) => finishUpload(image, done, 'under_trunk')}
                                            label='under_trunk'
                                        />
                                    </div>
                                </div>
                                <div className='col-6'>
                                    <div style={{backgroundColor:'#fff',padding:10,alignItems:'flex-end'}}>
                                        <p style={{fontSize:12}}> {t('Back glass')}</p>
                                        <ImagePickerModal
                                            disableGallery
                                            renderBtn={renderButton('back_glass')}
                                            upload={(image, done) => finishUpload(image, done, 'back_glass')}
                                            label='back_glass'
                                        />
                                    </div>
                                </div>
                            </>:
                            [6,7,9].includes(car_type_id)?
                                <>
                                    <div className='col-6'>
                                        <div style={{backgroundColor:'#fff',padding:10,alignItems:'flex-end'}}>
                                            <p style={{fontSize:12}}>{t('Tire')}</p>
                                            <ImagePickerModal
                                                disableGallery
                                                renderBtn={renderButton('tire')}
                                                upload={(image, done) => finishUpload(image, done, 'tire')}
                                                label='tire'
                                            />
                                        </div>
                                    </div>
                                    <div className='col-6'>
                                        <div style={{backgroundColor:'#fff',padding:10,alignItems:'flex-end'}}>
                                            <p style={{fontSize:12}}>{t('Using')}</p>
                                            <ImagePickerModal
                                                disableGallery
                                                renderBtn={renderButton('using')}
                                                upload={(image, done) => finishUpload(image, done, 'using')}
                                            />
                                        </div>
                                    </div>
                                </>:null

                    }
                    {

                        data.extraImages.map((itm)=>{
                            return(
                                <div className='col-6' key={itm.id}>
                                    <div style={{backgroundColor:'#fff',padding:10,alignItems:'flex-end'}}>
                                        <p style={{fontSize:12}}>{t('Image of accessories')}</p>
                                        <img
                                            src={`${url}/files?uid=${itm.uid}&width=70&height=70`}
                                            style={{width: 70, height: 70,marginTop:10}}
                                            alt='images'
                                        />
                                    </div>
                                </div>
                            )
                        })
                    }
                    {

                        data.damagesImages.map((itm)=>{
                            return(
                                <div className='col-6' key={itm.id}>
                                    <div style={{backgroundColor:'#fff',padding:10,alignItems:'flex-end'}}>
                                        <p style={{fontSize:12}}>{t('Images of damaged positions')}</p>
                                        <img
                                            src={`${url}/files?uid=${itm.uid}&width=70&height=70`}
                                            style={{width: 70, height: 70,marginTop:10}}
                                            alt='images'
                                        />
                                    </div>
                                </div>
                            )
                        })
                    }
                    <div className='col-6'>
                        <div style={{backgroundColor:'#fff',padding:10,alignItems:'flex-end'}}>
                            <p style={{fontSize:12}}>{t('Completment image')}</p>
                            <ImagePickerModal
                                disableGallery
                                renderBtn={<img src={addImage} alt='images' style={{width: 70, height: 70,marginTop:10}}/>}
                                upload={(image, done) => finishUpload(image, done, `extra-${data.extraImages.length + 1}`, 'extra')}
                            />
                        </div>
                    </div>
                    <div className='col-6'>
                        <div style={{backgroundColor:'#fff',padding:10,alignItems:'flex-end'}}>
                            <p style={{fontSize:12}}>{t('Images of damaged positions')}</p>
                            <ImagePickerModal
                                disableGallery
                                renderBtn={<img src={addImage} alt='images' style={{width: 70, height: 70,marginTop:10}}/>}
                                upload={(image, done) => finishUpload(image, done, `damage-${data.damagesImages.length + 1}`, 'damage')}
                            />
                        </div>
                    </div>
                </div>
                <div className='mt20'>
                    <button className='btn btn-green btn-block btn-circle' onClick={()=>validate()}>
                        {t('Submit')}
                    </button>
                </div>
            </>
        )
    //}

}
